import SubDepartmentDrawer from "../pages/drawer/sub-department-drawer";
import DepartmentDrawer from "../pages/drawer/department-drawer";
import MapProductDrawer from "../pages/drawer/map-product-drawer";
import AdminUserDrawer from "../pages/drawer/admin-user-drawer";
import SupplierDrawer from "../pages/drawer/supplier-drawer";
import AdminProductDrawer from "../pages/drawer/admin-product-drawer";
import SupplierProductDrawer from "../pages/drawer/supplier-product-drawer";
import ProductDrawer from "../pages/drawer/product-drawer";
import ContinousProductDrawer from "../pages/drawer/continous-product-drawer";
import SplitOrderDrawer from "../pages/drawer/split-order-drawer";
import OrderSummaryDrawer from "../pages/drawer/order-summary-drawer";
import PriceHistoryDrawer from "../pages/drawer/price-history-drawer";
import CreateReturnDrawer from "../pages/drawer/create-return-drawer";
import MessageStatusHistoryDrawer from "../pages/drawer/message-status-history-drawer";
export enum DrawerID {
  SubDepartment = 1,
  Department = 2,
  MapProduct = 3,
  AdminUser = 4,
  Supplier = 6,
  AdminProduct = 7,
  SupplierProduct = 8,
  Product = 9,
  ContinoutProductDrawer = 10,
  SplitOrderDrawer = 11,
  OrderSummary = 12,
  PriceHistory = 13,
  CreateReturn = 14,
  MessageStatusHistory = 15,
}

export const DrawerComponents: Record<DrawerID, React.ComponentType<any>> = {
  [DrawerID.SubDepartment]: SubDepartmentDrawer,
  [DrawerID.Department]: DepartmentDrawer,
  [DrawerID.MapProduct]: MapProductDrawer,
  [DrawerID.AdminUser]: AdminUserDrawer,
  [DrawerID.Supplier]: SupplierDrawer,
  [DrawerID.AdminProduct]: AdminProductDrawer,
  [DrawerID.SupplierProduct]: SupplierProductDrawer,
  [DrawerID.Product]: ProductDrawer,
  [DrawerID.ContinoutProductDrawer]: ContinousProductDrawer,
  [DrawerID.SplitOrderDrawer]: SplitOrderDrawer,
  [DrawerID.OrderSummary]: OrderSummaryDrawer,
  [DrawerID.PriceHistory]: PriceHistoryDrawer,
  [DrawerID.CreateReturn]: CreateReturnDrawer,
  [DrawerID.MessageStatusHistory]: MessageStatusHistoryDrawer,
};
